/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */

/**
 * Preferred Slovenian accounting export format.
 * @nullable
 */
export type ReviewSloveniaYearlyNormiraniReport200ProfileAccountingExportsPreferredFormat = typeof ReviewSloveniaYearlyNormiraniReport200ProfileAccountingExportsPreferredFormat[keyof typeof ReviewSloveniaYearlyNormiraniReport200ProfileAccountingExportsPreferredFormat] | null;


export const ReviewSloveniaYearlyNormiraniReport200ProfileAccountingExportsPreferredFormat = {
  vod_xml: 'vod_xml',
  vasco_xml: 'vasco_xml',
  minimax_xml: 'minimax_xml',
} as const;
